import React from 'react';
import CircleButton from 'components/Buttons/CircleButton';
import classNames from 'classnames';

const LocationCounter = ({ nfc = 0, qr = 0, gps = 0, beacon, onClick }) => {
  return (
    <div
      className={classNames('gx-flex-row gx-guarnic-gap-2', onClick && 'gx-pointer')}
      onClick={() => onClick?.()}
    >
      <div className="gx-flex-row gx-justify-content-center gx-align-items-center">
        <CircleButton type="secondary" iconName="qr_code_scanner" iconSize="sm" />
        <span>{qr}</span>
      </div>
      <div className="gx-flex-row gx-justify-content-center gx-align-items-center">
        <CircleButton type="secondary" iconName="location_on" iconSize="sm" />
        <span>{gps}</span>
      </div>
      <div className="gx-flex-row gx-justify-content-center gx-align-items-center">
        <CircleButton type="secondary" iconName="nfc" iconSize="sm" />
        <span>{nfc}</span>
      </div>
      {beacon !== undefined && (
        <div className="gx-flex-row gx-justify-content-center gx-align-items-center">
          <CircleButton type="secondary" iconName="bluetooth" iconSize="sm" />
          <span>{beacon}</span>
        </div>
      )}
    </div>
  );
};

export default React.memo(LocationCounter);
